import React from "react";

import AccommodationUnitSelector from "../../../../components/Accommodations/AccommodationUnitSelector";
import MenuDots from "../../../../components/MenuDots";
import {useDeleteRateMutation} from "../../query";
import {useFeedbackTools} from "../../../../components/FeedbackTools";
import StyledToggleButtonGroup from "../../../../components/StyledToggleButtonGroup";
import PeriodSummary from "./PeriodSummary";

import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import Card from "@mui/material/Card";
import Paper from "@mui/material/Paper";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {useRates} from "../../RateContext";


const RatesToolbar = (props) => {
    const {
        selectedRatesViewMode,
        onChangeRatesViewMode,
        onClickMassEdit,
        rateId
    } = props;

    const {accommodations, accUnitSelector} = useRates();
    const apartmentId = accUnitSelector.selectedAccommodationUnit?.id;
    const deleteMutation = useDeleteRateMutation({apartmentId, rateId});
    const {showErrorNotification, askConfirmation} = useFeedbackTools();

    const handleDelete = () => {
        const innerDelete = async () => {
            try{
                await deleteMutation.mutateAsync();
            }catch (e) {
                showErrorNotification("Errore durante l'eliminazione dei prezzi");
            }
        }
        askConfirmation({
            title: 'Elimina prezzo',
            description: "Sei sicuro di voler eliminare tutti i prezzi e tutte le condizioni dell'appartamento selezionato?",
            onConfirm: innerDelete
        })
    }

    return <Card sx={{width: "100%"}}>
        <Paper elevation={0} sx={{p: '12px 16px', minHeight: "72px", }}>
            <Stack direction="row" spacing={2} alignItems='center' justifyContent="flex-start">
                <AccommodationUnitSelector accommodationUnits={accommodations.accommodationUnits}
                                           value={accUnitSelector.selectedAccommodationUnit}
                                           onChange={accUnitSelector.handleChange}
                                           isLoading={accommodations.isLoading}
                                           sx={{mr: "auto!important"}}/>

                <PeriodSummary apartmentId={apartmentId}/>

                <StyledToggleButtonGroup
                    value={selectedRatesViewMode}
                    exclusive
                    onChange={onChangeRatesViewMode}
                    aria-label="rates view mode"
                    size="small"
                    color="primary"
                    sx={{ml: 'auto!important'}}
                >
                    <ToggleButton value="person" aria-label="person">
                        <PersonIcon fontSize="small"/> / notte
                    </ToggleButton>
                    <ToggleButton value="people" aria-label="people">
                        <GroupsIcon fontSize="small"/> / notte
                    </ToggleButton>
                </StyledToggleButtonGroup>

                <MenuDots options={[
                    {label: 'Modifica in blocco', icon: <EditIcon/>, onClick: onClickMassEdit},
                    {label: 'Elimina prezzi', icon: <DeleteIcon/>, onClick: handleDelete},
                ]}/>
            </Stack>
        </Paper>
    </Card>
}

export default RatesToolbar;